import React, { useEffect, useState } from 'react';
import TextInput from '../TextInput/TextInput';
import { validateInput } from '../../../utilities/validation/InputValidation';

function SelectOptionExtendedButton(props) {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    let initialErrors = {};
    props.buttonsData.forEach((button) => {
      initialErrors[button.value] = button.error || '';
    });
    setErrors(initialErrors);
  }, []);

  function changeHandler(e, button) {
    let inputValue = e.target.value;

    var error = validateInput(inputValue, button.textInputValidationType);
    setErrors({ ...errors, [button.value]: error });
    if (button.onChange) {
      button.onChange(button.value, inputValue, error);
    }
  }

  return (
    <div className={`select-option-button-container`}>
      <div className='select-option-button-title'>{props.title}</div>
      {props.buttonsData.map((button, index) => {
        return (
          <div key={index}>
            <button className={`select-option-button ${button.selected ? 'selected' : ''}`} onClick={() => props.onClick(button.value)}>
              <span className='select-option-button-text' dangerouslySetInnerHTML={{ __html: button.label }}></span>

              {button.rightContent && (
                <span className='select-option-button-right-content' dangerouslySetInnerHTML={{ __html: button.rightContent }}></span>
              )}
            </button>
            {button.selected && (
              <div className='select-option-button-input-container'>
                <TextInput
                  error={errors[button.value]}
                  onChange={(e) => button.disabled === true ? null : changeHandler(e, button)}
                  value={button.inputValue}
                  type={props.inputType ? props.inputType : 'text'}
                  placeholder={props.inputPlaceholder || ''}
                  pattern={button.pattern || ''}
                  maxLength={button.maxLength || ''}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default SelectOptionExtendedButton;
